"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TradeTrustTokenStandard__factory = void 0;

var _ethers = require("ethers");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const _abi = [{
  inputs: [],
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  inputs: [],
  name: "InvalidAdminAddress",
  type: "error"
}, {
  inputs: [],
  name: "InvalidTokenId",
  type: "error"
}, {
  inputs: [],
  name: "TokenExists",
  type: "error"
}, {
  inputs: [],
  name: "TokenNotSurrendered",
  type: "error"
}, {
  inputs: [],
  name: "TransferFailure",
  type: "error"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "Paused",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "bytes32",
    name: "previousAdminRole",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "bytes32",
    name: "newAdminRole",
    type: "bytes32"
  }],
  name: "RoleAdminChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "address",
    name: "account",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "sender",
    type: "address"
  }],
  name: "RoleGranted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "address",
    name: "account",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "sender",
    type: "address"
  }],
  name: "RoleRevoked",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "Transfer",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "Unpaused",
  type: "event"
}, {
  inputs: [],
  name: "ACCEPTER_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "DEFAULT_ADMIN_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "MINTER_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "RESTORER_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "owner",
    type: "address"
  }],
  name: "balanceOf",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "burn",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "genesis",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }],
  name: "getRoleAdmin",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "grantRole",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "hasRole",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes",
    name: "params",
    type: "bytes"
  }],
  name: "initialize",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "beneficiary",
    type: "address"
  }, {
    internalType: "address",
    name: "holder",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "mint",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "name",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "uint256",
    name: "",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "",
    type: "bytes"
  }],
  name: "onERC721Received",
  outputs: [{
    internalType: "bytes4",
    name: "",
    type: "bytes4"
  }],
  stateMutability: "pure",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "ownerOf",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "pause",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "paused",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "renounceRole",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "restore",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "revokeRole",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "string",
    name: "baseURI",
    type: "string"
  }],
  name: "setBaseURI",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "bytes32",
    name: "adminRole",
    type: "bytes32"
  }],
  name: "setRoleAdmin",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes4",
    name: "interfaceId",
    type: "bytes4"
  }],
  name: "supportsInterface",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "symbol",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "titleEscrowFactory",
  outputs: [{
    internalType: "contract ITitleEscrowFactory",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "tokenURI",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "transferFrom",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "unpause",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];
const _bytecode = "0x60806040523480156200001157600080fd5b50600054610100900460ff166200002f5760005460ff161562000039565b62000039620000de565b620000a15760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201526d191e481a5b9a5d1a585b1a5e995960921b606482015260840160405180910390fd5b600054610100900460ff16158015620000c4576000805461ffff19166101011790555b8015620000d7576000805461ff00191690555b506200010b565b6000620000f630620000fc60201b62000c131760201c565b15905090565b6001600160a01b03163b151590565b6125e8806200011b6000396000f3fe608060405234801561001057600080fd5b50600436106101c45760003560e01c80635c975abb116100f95780639bea62ad11610097578063c6c3bbe611610071578063c6c3bbe6146103dc578063c87b56dd146103ef578063d539139314610402578063d547741f1461042957600080fd5b80639bea62ad146103b9578063a217fddf146103cc578063a7f0b3de146103d457600080fd5b80637fb2977d116100d35780637fb2977d1461036f5780638456cb591461039657806391d148541461039e57806395d89b41146103b157600080fd5b80635c975abb1461033e5780636352211e1461034957806370a082311461035c57600080fd5b80632f2ff15d116101665780633f4ba83a116101405780633f4ba83a146102fd57806342966c6814610305578063439fab911461031857806355f804b31461032b57600080fd5b80632f2ff15d146102b2578063325689f9146102c557806336568abe146102ea57600080fd5b8063150b7a02116101a2578063150b7a021461023b5780631e4e00911461026757806323b872dd1461027c578063248a9ca31461028f57600080fd5b806301ffc9a7146101c957806306fdde03146101f157806311d4d7b514610206575b600080fd5b6101dc6101d7366004611e71565b61043c565b60405190151581526020015b60405180910390f35b6101f961045f565b6040516101e89190611ee6565b61022d7f4aca127bf16f434830a404b92851a3555910944351935eae88740d1cef5ffaad81565b6040519081526020016101e8565b61024e610249366004611fdb565b6104f1565b6040516001600160e01b031990911681526020016101e8565b61027a610275366004612047565b610502565b005b61027a61028a366004612069565b61051d565b61022d61029d3660046120aa565b600090815260c9602052604090206001015490565b61027a6102c03660046120c3565b6105ad565b60fc546001600160a01b03165b6040516001600160a01b0390911681526020016101e8565b61027a6102f83660046120c3565b6105d3565b61027a610651565b61027a6103133660046120aa565b610668565b61027a6103263660046120f3565b6106bf565b61027a610339366004612128565b6107e2565b60975460ff166101dc565b6102d26103573660046120aa565b6107f7565b61022d61036a366004612171565b61086e565b61022d7fe5fe4715ff8709ff44f5e6bb664620f9349f5f6ae81a532eba2a43b9598ba7eb81565b61027a6108f5565b6101dc6103ac3660046120c3565b610909565b6101f9610934565b6102d26103c73660046120aa565b610943565b61022d600081565b60fd5461022d565b6102d26103ea366004612069565b610aa8565b6101f96103fd3660046120aa565b610b12565b61022d7f9f2df0fed2c77648de5860a4cc508cd0818c85b8b8a1ab4ceeef8d981c8956a681565b61027a6104373660046120c3565b610bed565b60006001600160e01b031982161580610459575061045982610c22565b92915050565b60606065805461046e9061218e565b80601f016020809104026020016040519081016040528092919081815260200182805461049a9061218e565b80156104e75780601f106104bc576101008083540402835291602001916104e7565b820191906000526020600020905b8154815290600101906020018083116104ca57829003601f168201915b5050505050905090565b630a85bd0160e11b5b949350505050565b600061050e8133610c47565b6105188383610cab565b505050565b6105273382610cf6565b6105925760405162461bcd60e51b815260206004820152603160248201527f4552433732313a207472616e736665722063616c6c6572206973206e6f74206f6044820152701ddb995c881b9bdc88185c1c1c9bdd9959607a1b60648201526084015b60405180910390fd5b61051883838360405180602001604052806000815250610d91565b600082815260c960205260409020600101546105c98133610c47565b6105188383610dca565b6001600160a01b03811633146106435760405162461bcd60e51b815260206004820152602f60248201527f416363657373436f6e74726f6c3a2063616e206f6e6c792072656e6f756e636560448201526e103937b632b9903337b91039b2b63360891b6064820152608401610589565b61064d8282610e50565b5050565b600061065d8133610c47565b610665610eb7565b50565b60975460ff161561068b5760405162461bcd60e51b8152600401610589906121c3565b7fe5fe4715ff8709ff44f5e6bb664620f9349f5f6ae81a532eba2a43b9598ba7eb6106b68133610c47565b61064d82610f4a565b600054610100900460ff166106da5760005460ff16156106de565b303b155b6107415760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201526d191e481a5b9a5d1a585b1a5e995960921b6064820152608401610589565b600054610100900460ff16158015610763576000805461ffff19166101011790555b6000808380602001905181019061077a919061221d565b915091506000806000848060200190518101906107979190612298565b4360fd5560fc80546001600160a01b0319166001600160a01b038916179055919450925090506107c883838361103f565b5050505050801561064d576000805461ff00191690555050565b60006107ee8133610c47565b61064d82611079565b6000818152606760205260408120546001600160a01b0316806104595760405162461bcd60e51b815260206004820152602960248201527f4552433732313a206f776e657220717565727920666f72206e6f6e657869737460448201526832b73a103a37b5b2b760b91b6064820152608401610589565b60006001600160a01b0382166108d95760405162461bcd60e51b815260206004820152602a60248201527f4552433732313a2062616c616e636520717565727920666f7220746865207a65604482015269726f206164647265737360b01b6064820152608401610589565b506001600160a01b031660009081526068602052604090205490565b60006109018133610c47565b61066561108c565b600091825260c9602090815260408084206001600160a01b0393909316845291905290205460ff1690565b60606066805461046e9061218e565b600061095160975460ff1690565b1561096e5760405162461bcd60e51b8152600401610589906121c3565b7f4aca127bf16f434830a404b92851a3555910944351935eae88740d1cef5ffaad6109998133610c47565b6000838152606760205260409020546001600160a01b03166109ce576040516307ed98ed60e31b815260040160405180910390fd5b306109d8846107f7565b6001600160a01b0316146109ff57604051631ed483eb60e01b815260040160405180910390fd5b6000610a1360fc546001600160a01b031690565b60405163119709c360e31b8152306004820152602481018690526001600160a01b039190911690638cb84e189060440160206040518083038186803b158015610a5b57600080fd5b505afa158015610a6f573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610a939190612310565b9050610a9f81856110e4565b91505b50919050565b6000610ab660975460ff1690565b15610ad35760405162461bcd60e51b8152600401610589906121c3565b7f9f2df0fed2c77648de5860a4cc508cd0818c85b8b8a1ab4ceeef8d981c8956a6610afe8133610c47565b610b0985858561114f565b95945050505050565b6000818152606760205260409020546060906001600160a01b0316610b915760405162461bcd60e51b815260206004820152602f60248201527f4552433732314d657461646174613a2055524920717565727920666f72206e6f60448201526e3732bc34b9ba32b73a103a37b5b2b760891b6064820152608401610589565b6000610b9b61125b565b90506000815111610bbb5760405180602001604052806000815250610be6565b80610bc58461126a565b604051602001610bd692919061232d565b6040516020818303038152906040525b9392505050565b600082815260c96020526040902060010154610c098133610c47565b6105188383610e50565b6001600160a01b03163b151590565b60006001600160e01b03198216639bea62ad60e01b1480610459575061045982611368565b610c518282610909565b61064d57610c69816001600160a01b0316601461138d565b610c7483602061138d565b604051602001610c8592919061235c565b60408051601f198184030181529082905262461bcd60e51b825261058991600401611ee6565b600082815260c96020526040808220600101805490849055905190918391839186917fbd79b86ffe0ab8e8776151514217cd7cacd52c909f66475c3af44e129f0b00ff9190a4505050565b6000818152606760205260408120546001600160a01b0316610d6f5760405162461bcd60e51b815260206004820152602c60248201527f4552433732313a206f70657261746f7220717565727920666f72206e6f6e657860448201526b34b9ba32b73a103a37b5b2b760a11b6064820152608401610589565b6000610d7a836107f7565b6001600160a01b0385811691161491505092915050565b610d9c848484611529565b610da8848484846116c5565b610dc45760405162461bcd60e51b8152600401610589906123d1565b50505050565b610dd48282610909565b61064d57600082815260c9602090815260408083206001600160a01b03851684529091529020805460ff19166001179055610e0c3390565b6001600160a01b0316816001600160a01b0316837f2f8788117e7eff1d82e926ec794901d17c78024a50270940304540a733656f0d60405160405180910390a45050565b610e5a8282610909565b1561064d57600082815260c9602090815260408083206001600160a01b0385168085529252808320805460ff1916905551339285917ff6391f5c32d9c69d2a47ea670b442974b53935d1edc7fd64eb21e047a839171b9190a45050565b60975460ff16610f005760405162461bcd60e51b815260206004820152601460248201527314185d5cd8589b194e881b9bdd081c185d5cd95960621b6044820152606401610589565b6097805460ff191690557f5db9ee0a495bf2e6ff9c91a7834c1ba4fdd244a5e8aa4e537bd38aeae4b073aa335b6040516001600160a01b03909116815260200160405180910390a1565b6000610f5e60fc546001600160a01b031690565b60405163119709c360e31b8152306004820152602481018490526001600160a01b039190911690638cb84e189060440160206040518083038186803b158015610fa657600080fd5b505afa158015610fba573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610fde9190612310565b9050806001600160a01b0316634302885d6040518163ffffffff1660e01b8152600401600060405180830381600087803b15801561101b57600080fd5b505af115801561102f573d6000803e3d6000fd5b5050505061064d61dead836110e4565b600054610100900460ff166110665760405162461bcd60e51b815260040161058990612423565b61107083836117cf565b61051881611808565b805161064d9060fb906020840190611dc2565b60975460ff16156110af5760405162461bcd60e51b8152600401610589906121c3565b6097805460ff191660011790557f62e78cea01bee320cd4e420270b5ea74000d11b0c9f74754ebdbfc544b05a258610f2d3390565b6040516323b872dd60e01b815230600482018190526001600160a01b038416602483015260448201839052906323b872dd90606401600060405180830381600087803b15801561113357600080fd5b505af1158015611147573d6000803e3d6000fd5b505050505050565b6000818152606760205260408120546001600160a01b03161561118557604051632ae3f45d60e11b815260040160405180910390fd5b600061119960fc546001600160a01b031690565b6001600160a01b031663780900dc846040518263ffffffff1660e01b81526004016111c691815260200190565b602060405180830381600087803b1580156111e057600080fd5b505af11580156111f4573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906112189190612310565b90506104fa818487876040516020016112479291906001600160a01b0392831681529116602082015260400190565b6040516020818303038152906040526118df565b6060611265611912565b905090565b60608161128e5750506040805180820190915260018152600360fc1b602082015290565b8160005b81156112b857806112a281612484565b91506112b19050600a836124b5565b9150611292565b60008167ffffffffffffffff8111156112d3576112d3611f0e565b6040519080825280601f01601f1916602001820160405280156112fd576020820181803683370190505b5090505b84156104fa576113126001836124c9565b915061131f600a866124e0565b61132a9060306124f4565b60f81b81838151811061133f5761133f61250c565b60200101906001600160f81b031916908160001a905350611361600a866124b5565b9450611301565b60006001600160e01b03198216636361ddf360e11b1480610459575061045982611921565b6060600061139c836002612522565b6113a79060026124f4565b67ffffffffffffffff8111156113bf576113bf611f0e565b6040519080825280601f01601f1916602001820160405280156113e9576020820181803683370190505b509050600360fc1b816000815181106114045761140461250c565b60200101906001600160f81b031916908160001a905350600f60fb1b816001815181106114335761143361250c565b60200101906001600160f81b031916908160001a9053506000611457846002612522565b6114629060016124f4565b90505b60018111156114da576f181899199a1a9b1b9c1cb0b131b232b360811b85600f16601081106114965761149661250c565b1a60f81b8282815181106114ac576114ac61250c565b60200101906001600160f81b031916908160001a90535060049490941c936114d381612541565b9050611465565b508315610be65760405162461bcd60e51b815260206004820181905260248201527f537472696e67733a20686578206c656e67746820696e73756666696369656e746044820152606401610589565b826001600160a01b031661153c826107f7565b6001600160a01b0316146115a05760405162461bcd60e51b815260206004820152602560248201527f4552433732313a207472616e736665722066726f6d20696e636f72726563742060448201526437bbb732b960d91b6064820152608401610589565b6001600160a01b0382166116025760405162461bcd60e51b8152602060048201526024808201527f4552433732313a207472616e7366657220746f20746865207a65726f206164646044820152637265737360e01b6064820152608401610589565b61160d838383611946565b6001600160a01b03831660009081526068602052604081208054600192906116369084906124c9565b90915550506001600160a01b03821660009081526068602052604081208054600192906116649084906124f4565b909155505060008181526067602052604080822080546001600160a01b0319166001600160a01b0386811691821790925591518493918716917fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef91a4505050565b60006001600160a01b0384163b156117c757604051630a85bd0160e11b81526001600160a01b0385169063150b7a0290611709903390899088908890600401612558565b602060405180830381600087803b15801561172357600080fd5b505af1925050508015611753575060408051601f3d908101601f1916820190925261175091810190612595565b60015b6117ad573d808015611781576040519150601f19603f3d011682016040523d82523d6000602084013e611786565b606091505b5080516117a55760405162461bcd60e51b8152600401610589906123d1565b805181602001fd5b6001600160e01b031916630a85bd0160e11b1490506104fa565b5060016104fa565b600054610100900460ff166117f65760405162461bcd60e51b815260040161058990612423565b6118008282611a6a565b61064d611a9b565b600054610100900460ff1661182f5760405162461bcd60e51b815260040161058990612423565b6001600160a01b0381166118565760405163016ed19f60e21b815260040160405180910390fd5b611861600082611acc565b61188b7f9f2df0fed2c77648de5860a4cc508cd0818c85b8b8a1ab4ceeef8d981c8956a682611acc565b6118b57f4aca127bf16f434830a404b92851a3555910944351935eae88740d1cef5ffaad82611acc565b6106657fe5fe4715ff8709ff44f5e6bb664620f9349f5f6ae81a532eba2a43b9598ba7eb82611acc565b6118e98383611ad6565b6118f660008484846116c5565b6105185760405162461bcd60e51b8152600401610589906123d1565b606060fb805461046e9061218e565b60006001600160e01b03198216630852cd8d60e31b1480610459575061045982611c24565b60975460ff16156119695760405162461bcd60e51b8152600401610589906121c3565b611974838383611c2f565b600061198860fc546001600160a01b031690565b60405163119709c360e31b8152306004820152602481018490526001600160a01b039190911690638cb84e189060440160206040518083038186803b1580156119d057600080fd5b505afa1580156119e4573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611a089190612310565b90506001600160a01b0383163014801590611a355750806001600160a01b0316836001600160a01b031614155b8015611a4c57506001600160a01b03831661dead14155b15610dc457604051637bf340bd60e11b815260040160405180910390fd5b600054610100900460ff16611a915760405162461bcd60e51b815260040161058990612423565b61064d8282611c83565b600054610100900460ff16611ac25760405162461bcd60e51b815260040161058990612423565b611aca611cd1565b565b61064d8282610dca565b6001600160a01b038216611b2c5760405162461bcd60e51b815260206004820181905260248201527f4552433732313a206d696e7420746f20746865207a65726f20616464726573736044820152606401610589565b6000818152606760205260409020546001600160a01b031615611b915760405162461bcd60e51b815260206004820152601c60248201527f4552433732313a20746f6b656e20616c7265616479206d696e746564000000006044820152606401610589565b611b9d60008383611946565b6001600160a01b0382166000908152606860205260408120805460019290611bc69084906124f4565b909155505060008181526067602052604080822080546001600160a01b0319166001600160a01b03861690811790915590518392907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef908290a45050565b600061045982611d04565b6001600160a01b03821661dead148015611c5a575030611c4e826107f7565b6001600160a01b031614155b15611c7857604051631ed483eb60e01b815260040160405180910390fd5b610518838383611d0f565b600054610100900460ff16611caa5760405162461bcd60e51b815260040161058990612423565b8151611cbd906065906020850190611dc2565b508051610518906066906020840190611dc2565b600054610100900460ff16611cf85760405162461bcd60e51b815260040161058990612423565b6097805460ff19169055565b600061045982611d32565b60975460ff16156105185760405162461bcd60e51b8152600401610589906121c3565b60006001600160e01b03198216637965db0b60e01b148061045957506104598260006001600160e01b031982166395a63a2760e01b148061045957506104598260006001600160e01b0319821663182568f960e11b1480611da357506001600160e01b03198216635b5e139f60e01b145b8061045957506301ffc9a760e01b6001600160e01b0319831614610459565b828054611dce9061218e565b90600052602060002090601f016020900481019282611df05760008555611e36565b82601f10611e0957805160ff1916838001178555611e36565b82800160010185558215611e36579182015b82811115611e36578251825591602001919060010190611e1b565b50611e42929150611e46565b5090565b5b80821115611e425760008155600101611e47565b6001600160e01b03198116811461066557600080fd5b600060208284031215611e8357600080fd5b8135610be681611e5b565b60005b83811015611ea9578181015183820152602001611e91565b83811115610dc45750506000910152565b60008151808452611ed2816020860160208601611e8e565b601f01601f19169290920160200192915050565b602081526000610be66020830184611eba565b6001600160a01b038116811461066557600080fd5b634e487b7160e01b600052604160045260246000fd5b604051601f8201601f1916810167ffffffffffffffff81118282101715611f4d57611f4d611f0e565b604052919050565b600067ffffffffffffffff821115611f6f57611f6f611f0e565b50601f01601f191660200190565b6000611f90611f8b84611f55565b611f24565b9050828152838383011115611fa457600080fd5b828260208301376000602084830101529392505050565b600082601f830112611fcc57600080fd5b610be683833560208501611f7d565b60008060008060808587031215611ff157600080fd5b8435611ffc81611ef9565b9350602085013561200c81611ef9565b925060408501359150606085013567ffffffffffffffff81111561202f57600080fd5b61203b87828801611fbb565b91505092959194509250565b6000806040838503121561205a57600080fd5b50508035926020909101359150565b60008060006060848603121561207e57600080fd5b833561208981611ef9565b9250602084013561209981611ef9565b929592945050506040919091013590565b6000602082840312156120bc57600080fd5b5035919050565b600080604083850312156120d657600080fd5b8235915060208301356120e881611ef9565b809150509250929050565b60006020828403121561210557600080fd5b813567ffffffffffffffff81111561211c57600080fd5b6104fa84828501611fbb565b60006020828403121561213a57600080fd5b813567ffffffffffffffff81111561215157600080fd5b8201601f8101841361216257600080fd5b6104fa84823560208401611f7d565b60006020828403121561218357600080fd5b8135610be681611ef9565b600181811c908216806121a257607f821691505b60208210811415610aa257634e487b7160e01b600052602260045260246000fd5b60208082526010908201526f14185d5cd8589b194e881c185d5cd95960821b604082015260600190565b60006121fb611f8b84611f55565b905082815283838301111561220f57600080fd5b610be6836020830184611e8e565b6000806040838503121561223057600080fd5b825167ffffffffffffffff81111561224757600080fd5b8301601f8101851361225857600080fd5b612267858251602084016121ed565b92505060208301516120e881611ef9565b600082601f83011261228957600080fd5b610be6838351602085016121ed565b6000806000606084860312156122ad57600080fd5b835167ffffffffffffffff808211156122c557600080fd5b6122d187838801612278565b945060208601519150808211156122e757600080fd5b506122f486828701612278565b925050604084015161230581611ef9565b809150509250925092565b60006020828403121561232257600080fd5b8151610be681611ef9565b6000835161233f818460208801611e8e565b835190830190612353818360208801611e8e565b01949350505050565b7f416363657373436f6e74726f6c3a206163636f756e7420000000000000000000815260008351612394816017850160208801611e8e565b7001034b99036b4b9b9b4b733903937b6329607d1b60179184019182015283516123c5816028840160208801611e8e565b01602801949350505050565b60208082526032908201527f4552433732313a207472616e7366657220746f206e6f6e20455243373231526560408201527131b2b4bb32b91034b6b83632b6b2b73a32b960711b606082015260800190565b6020808252602b908201527f496e697469616c697a61626c653a20636f6e7472616374206973206e6f74206960408201526a6e697469616c697a696e6760a81b606082015260800190565b634e487b7160e01b600052601160045260246000fd5b60006000198214156124985761249861246e565b5060010190565b634e487b7160e01b600052601260045260246000fd5b6000826124c4576124c461249f565b500490565b6000828210156124db576124db61246e565b500390565b6000826124ef576124ef61249f565b500690565b600082198211156125075761250761246e565b500190565b634e487b7160e01b600052603260045260246000fd5b600081600019048311821515161561253c5761253c61246e565b500290565b6000816125505761255061246e565b506000190190565b6001600160a01b038581168252841660208201526040810183905260806060820181905260009061258b90830184611eba565b9695505050505050565b6000602082840312156125a757600080fd5b8151610be681611e5b56fea2646970667358221220320344a1295ae0ab6c4c92a2b2d52473b22dbb3286b4451f73a7db40fb4e679664736f6c63430008090033";

const isSuperArgs = xs => xs.length > 1;

class TradeTrustTokenStandard__factory extends _ethers.ContractFactory {
  constructor(...args) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(overrides) {
    return super.deploy(overrides || {});
  }

  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }

  attach(address) {
    return super.attach(address);
  }

  connect(signer) {
    return super.connect(signer);
  }

  static createInterface() {
    return new _ethers.utils.Interface(_abi);
  }

  static connect(address, signerOrProvider) {
    return new _ethers.Contract(address, _abi, signerOrProvider);
  }

}

exports.TradeTrustTokenStandard__factory = TradeTrustTokenStandard__factory;

_defineProperty(TradeTrustTokenStandard__factory, "bytecode", _bytecode);

_defineProperty(TradeTrustTokenStandard__factory, "abi", _abi);